import ReachPortal from '@reach/portal';
export const Portal = ReachPortal;
